import sweetAlert from "sweetalert2";
import { NotificationManager } from "react-notifications";
import { defineMessages } from "react-intl";
import faMessage from "../lngProvider/locales/fa_IR.json";
import enMessage from "../lngProvider/locales/en_US.json";

export const ShowSuccess = (title: string, content: string) => {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);

    if (!title || title === null || title === "")
        title = messages["messages.operationWasSuccessful"];

    NotificationManager.success(title, content, 1500);
}

let errorCount = 0;

export const ShowError = (title: string, content: any) => {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);

    if (content.response && content.response.status === 401) {

        if (content.response.statusText === "NoPwaAccess") {
            if (errorCount === 0) {
                NotificationManager.error(messages["messages.loginError"], messages["messages.youDontHaveAccessToUseMobileVersion"], 3000)
                setTimeout(() => {
                    return window.location.href = window.location.origin + "/auth/logout";
                }, 3000);
                errorCount = 1;
            }
            return;
        }
        else {
            window.location.href = window.location.origin + "/auth/logout";
            return;
        }
    }
    if (!title || title === null || title === "")
        title = messages["messages.errorOccur"];
    if (content.response && content.response.data && content.response.data.exceptionMessage)
        content = content.response.data.exceptionMessage;

    typeof (content) !== "string" ? NotificationManager.error(title, "", 3000) : NotificationManager.error(title, content, 3000);
}

export const ShowWarning = (title: string, content: any) => {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);

    if (content.response && content.response.status === 401) {

        if (content.response.statusText === "NoPwaAccess") {
            if (errorCount === 0) {
                NotificationManager.warning(messages["messages.loginError"], messages["messages.youDontHaveAccessToUseMobileVersion"], 3000)
                setTimeout(() => {
                    return window.location.href = window.location.origin + "/auth/logout";
                }, 3000);
                errorCount = 1;
            }
            return;
        }
        else
            return window.location.href = window.location.origin + "/auth/logout";
    }
    if (!title || title === null || title === "")
        title = messages["messages.errorOccur"];
    if (content.response && content.response.data && content.response.data.exceptionMessage)
        content = content.response.data.exceptionMessage;

    typeof (content) !== "string" ? NotificationManager.warning(title, "", 3000) : NotificationManager.warning(title, content, 3000);
}

export const ShowConfirm = (title: string, content: string, confirmButtonText?: string, cancelButtonText?: string, confirmCallback?: any, cancelCallback?: any) => {
    sweetAlert.fire({
        title: title,
        text: content,
        showCancelButton: cancelCallback !== null,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showConfirmButton: confirmCallback != null
    }).then((result: any) => {
        if (result.isConfirmed) {
            if (confirmCallback)
                confirmCallback();
        } else if (result.dismiss === sweetAlert.DismissReason.cancel) {
            if (cancelCallback)
                cancelCallback();
        }

    })
}

